/**
 * MaisonKlaviyo — shared Klaviyo tracking utility for all tracking.
 *
 * Uses the _learnq push API. Events are queued and replayed when the
 * Klaviyo SDK fully loads.
 *
 * Email is persisted in localStorage so it survives across pages and sessions.
 * Every track() call auto-identifies if an email is available.
 *
 * Usage:
 *   MaisonKlaviyo.identify({ $email: 'x@y.com', $first_name: 'X' })
 *   MaisonKlaviyo.trackWithEmail(email, 'SavedConfiguration', payload)
 *   MaisonKlaviyo.track('SavedConfiguration', payload)
 */
(function () {
  'use strict';

  var TAG = '[MaisonKlaviyo]';
  var EMAIL_KEY = 'maison_klaviyo_email';

  function getQueue() {
    window._learnq = window._learnq || [];
    return window._learnq;
  }

  function setEmail(email) {
    if (!email) return;
    identify({ '$email': email });
  }

  function getEmail() {
    try { return localStorage.getItem(EMAIL_KEY) || null; } catch (e) { return null; }
  }

  function buildSavedConfigPayload(opts) {
    var payload = {
      configurator_type: opts.configurator_type || '',
      product_category: opts.product_category || '',
      url: opts.url || '',
      price: opts.price || 0,
      currency: opts.currency || (typeof Shopify !== 'undefined' && Shopify.currency ? Shopify.currency.active : 'EUR'),
      delivery_time: opts.delivery_time || '',
      Language_Locale: opts.locale || (typeof Shopify !== 'undefined' ? Shopify.locale : ''),
    };

    if (opts.email) payload.email = opts.email;
    if (opts.image_url) payload.image_url = opts.image_url;
    if (opts.extras && typeof opts.extras === 'object') {
      for (var key in opts.extras) {
        if (opts.extras.hasOwnProperty(key)) {
          payload[key] = opts.extras[key];
        }
      }
    }

    return payload;
  }

  function identify(profileData) {
    var lq = getQueue();
    console.log(TAG, 'identify:', profileData.$email || profileData);
    lq.push(['identify', profileData]);
    // Persist email to localStorage whenever we identify
    if (profileData && profileData.$email) {
      try { localStorage.setItem(EMAIL_KEY, profileData.$email); } catch (e) { /* private browsing */ }
    }
  }

  function trackWithEmail(email, eventName, properties) {
    if (email) {
      setEmail(email);
      var lq = getQueue();
      console.log(TAG, 'track:', eventName, properties);
      lq.push(['track', eventName, properties]);
    } else {
      track(eventName, properties);
    }
    return Promise.resolve();
  }

  function track(eventName, properties) {
    var lq = getQueue();
    // Auto-identify from localStorage if email exists
    var email = getEmail();
    if (email) {
      lq.push(['identify', { '$email': email }]);
    }
    console.log(TAG, 'track:', eventName, properties);
    lq.push(['track', eventName, properties]);
    return Promise.resolve();
  }

  // Capture email from any Shopify form submission (newsletter, contact, login, register)
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var emailInput = form.querySelector(
      'input[name="contact[email]"], input[name="customer[email]"]'
    );
    if (emailInput && emailInput.value) {
      setEmail(emailInput.value.trim());
    }
  }, true);  // capture phase — fires before stopPropagation in maison-contact form

  // Capture email from Klaviyo's own embedded forms (footer newsletter signups)
  window.addEventListener('klaviyoForms', function(e) {
    if (e.detail && e.detail.type === 'submit' && e.detail.metaData && e.detail.metaData.$email) {
      setEmail(e.detail.metaData.$email);
    }
  });

  window.MaisonKlaviyo = {
    buildSavedConfigPayload: buildSavedConfigPayload,
    identify: identify,
    trackWithEmail: trackWithEmail,
    track: track,
    setEmail: setEmail,
    getEmail: getEmail,
  };
})();
